import React from 'react';
import { Popover, Typography, useTheme, Link, Stack } from '@mui/material';
import { Player } from '../room/types';

type PropTypes = {
  anchorEl: Element;
  close: () => void;
  gameOver: boolean;
  handleUsernameClick: (e: any, player: Player) => void;
  players: Player[];
  open: boolean;
  ranked: boolean;
};

export const JoinedPlayersMorePopover = ({
  anchorEl,
  close,
  gameOver,
  handleUsernameClick,
  players,
  open,
  ranked,
}: PropTypes) => {
  const theme = useTheme();

  const getRatingNextToUsername = (gameOver: boolean, player: Player) => {
    const formatRating = (rating: number) => {
      const rounded = Math.round(rating);
      return `${rounded > 0 ? '+' : ''}${rounded}`;
    };

    if (gameOver) {
      return formatRating(player.rankedRatingDiff || 0);
    }
    return (player.rankedMatchGamesPlayed || 0) +
      (player.rankedSitAndGoGamesPlayed || 0) <
      10
      ? 'calibrating'
      : player.rankedRating;
  };

  const ratingColor = (gameOver: boolean, player: Player) => {
    if (gameOver) {
      if (Math.round(player.rankedRatingDiff || 0) > 0)
        return theme.palette.success.main;
      if (Math.round(player.rankedRatingDiff || 0) < 0)
        return theme.palette.error.main;
      return theme.palette.warning.main;
    }
    return theme.palette.ranked.main;
  };
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={close}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Stack
        sx={{
          paddingY: 1,
          paddingX: 2,
          height: 400,
        }}
      >
        {players.slice(20, players.length).map((p, i) => (
          <Link
            key={i}
            component="button"
            variant="body2"
            onClick={(e) => handleUsernameClick(e, p)}
            textAlign={'left'}
          >
            <Stack direction={'row'} sx={{ whiteSpace: 'nowrap' }}>
              {gameOver ? p.rank : i + 21}. {p.username}
              {ranked ? (
                <Stack direction={'row'}>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ color: theme.palette.ranked.main }}
                  >
                    &nbsp;(
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ color: ratingColor(gameOver, p) }}
                  >
                    {getRatingNextToUsername(gameOver, p)}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ color: theme.palette.ranked.main }}
                  >
                    )
                  </Typography>
                </Stack>
              ) : null}
            </Stack>
          </Link>
        ))}
      </Stack>
    </Popover>
  );
};
